import { render, staticRenderFns } from "./small-payment-audit-log.vue?vue&type=template&id=0cfc6ecc&scoped=true"
import script from "./small-payment-audit-log.vue?vue&type=script&lang=ts"
export * from "./small-payment-audit-log.vue?vue&type=script&lang=ts"
import style0 from "./small-payment-audit-log.vue?vue&type=style&index=0&id=0cfc6ecc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfc6ecc",
  null
  
)

export default component.exports